module.exports = __webpack_public_path__ + "img/tj.5e61ac17.png";